import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdFile: FC<tSvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 100 100" fill="none" {...props}>
      <Path
        d="m63.102 7.1016c-1.3008-1.4023-3-2.1016-4.9023-2.1016h-32.098c-4.1016 0-7.3984 3.3008-7.3984 7.3984v33h-9.1016c-2.6016 0-4.8008 2.1016-4.8008 4.8008v17.102c0 2.6016 2.1016 4.8008 4.8008 4.8008h44.699c2.6016 0 4.8008-2.1016 4.8008-4.8008v-17.102c0-2.6016-2.1016-4.8008-4.8008-4.8008h-27.602v-32c0-0.19922 0.19922-0.39844 0.39844-0.39844h30.699c1.1992 0 2.1992 1 2.1992 2.1992l0.003906 13.801c0 4.1016 3.3008 7.3984 7.3984 7.3984h13.102c1.1992 0 2.1992 1 2.1992 2.1992v48c0 0.19922-0.19922 0.39844-0.39844 0.39844l-55.199 0.003906c-0.19922 0-0.39844-0.19922-0.39844-0.39844v-6.5c0-0.60156-0.5-1.1992-1.1992-1.1992h-5.6992c-0.60156 0-1.1992 0.5-1.1992 1.1992v7.5c0 4.1016 3.3008 7.3984 7.3984 7.3984h57.301c4.1016 0 7.3984-3.3008 7.3984-7.3984l-0.003906-49.402c0-1.8008-0.69922-3.5-1.8984-4.8008z"
        fill="currentColor"
      />
    </Svg>
  );
};

export default PdFile;
